import { Component, HostBinding } from '@angular/core';
import { Input } from '@angular/core';
import { TooltipContentComponent } from '../tooltip';

@Component({
  selector: 'ula-input-base',
  templateUrl: './ula-input-base.template.html',
  styleUrls: [ './ula-input-base.style.scss' ]
})
export class UlaInputBaseComponent {
  @Input() labelPrefix: string;
  @Input() hasValidationError = false;
  @Input() label: string;
  // TODO: ld-tooltip will be replaced by ula-tooltip; this is a breaking change
  @Input() popover: string | TooltipContentComponent;
  @Input() popoverPlacement: 'top'|'bottom'|'left'|'right' = 'right';
  @Input() title = '';
  @Input() titleIconBefore: string = null;
  @Input() titleIconAfter: string = null;

  // omitting the '_class' variable name doesn't seem to correctly apply the CSS class,
  // so don't omit it
  @HostBinding('class') _class = 'd-block';

  preventDefault(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}
